import Vue from 'vue'
import SvgIcon from 'vue-svgicon'

Vue.use(SvgIcon, {
  tagName: 'svgicon',
})
